import React from 'react';
import translate from '../translate';
import {UsagePeriod} from '../../store/usageDataSlice';
import {Link} from 'react-router';

interface Props {
    strings: any;
    year: number;
    months: {
        [month: number]: UsagePeriod;
    };
}

interface State {
    active: boolean;
}

class UsageOverviewItem extends React.Component<Props, State> {
    state: State = {
        active: false,
    };

    _toggle = () => this.setState({ active: !this.state.active });

    _renderMonths = () => {
        return (
            <ul className="month-wrapper">
                <div className="col">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>{this.props.strings.month}</th>
                                <th>{this.props.strings.cycles}</th>
                                <th>{this.props.strings.amount}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(this.props.months)
                                .sort(([_, a], [__, b]) => b.month - a.month)
                                .map(([_, it]) => (
                                    <tr key={it.period}>
                                        <td>{it.month}</td>
                                        <td>{it.cycles}</td>
                                        <td>
                                            {this.props.strings._utils.formatPrice(
                                                {
                                                    amount: it.amount,
                                                    currency: it.currency,
                                                }
                                            )}
                                        </td>
                                        <td>
                                            <Link
                                                to={`/usage-data/${it.period}`}
                                                className="icon icon-wew-button-enter icon-sm"
                                            />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </ul>
        );
    };

    render() {
        const active = this.state.active ? ' active' : '';
        return (
            <ul className="year-wrapper">
                <li className={`year${active}`}>
                    <div className="title " onClick={this._toggle}>
                        <i className="icon icon-wew-arrow-right icon-sm active-indicator" />
                        <span>{this.props.year}</span>
                    </div>
                    {this._renderMonths()}
                </li>
            </ul>
        );
    }
}

export default translate('UsagePeriodItem')(UsageOverviewItem);
